import useMutation from "src/hooks/useMutation";

function useManufacturerCreate() {
  return useMutation({
    path: "/api/v1/manufacturers",
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/manufacturers`,
      shouldRevalidate: true,
    },
  });
}

export default useManufacturerCreate;
